export type LibraryKind = "writing" | "work" | "play";

export function parseTags(raw: unknown): string[] {
  if (typeof raw !== "string") return [];
  // Supports: "A, B, C" and/or "A B C" legacy formats.
  return raw
    .split(/[,]/g)
    .flatMap((chunk) => chunk.split(/\s{2,}|\s\|\s/g))
    .flatMap((chunk) => chunk.split(/\s+/g))
    .map((t) => t.trim())
    .filter(Boolean);
}

export function uniqueTags(values: Array<string | undefined | null>): string[] {
  const set = new Set<string>();
  for (const v of values) {
    for (const t of parseTags(v)) set.add(t);
  }
  return Array.from(set).sort((a, b) => a.localeCompare(b));
}

// getWorkLogoEntries() removed - data migrated to library.json as design-project entries


const MONTHS = ["jan", "feb", "mar", "apr", "may", "jun", "jul", "aug", "sep", "oct", "nov", "dec"];

// Client-side twin of parseEntryDate in scripts/content-utils.js: "Oct 2026" → a
// sortable number (year * 12 + month), or -1 for an undated entry.
export function entryDateValue(value: unknown): number {
  if (typeof value !== "string") return -1;
  const m = value.trim().match(/^([A-Za-z]{3})[a-z]*\s+(\d{4})$/);
  if (!m) return -1;
  const month = MONTHS.indexOf(m[1].toLowerCase());
  return month < 0 ? -1 : parseInt(m[2], 10) * 12 + month;
}

type Dated = { date?: string; featured?: boolean };

// Newest first. Undated entries keep their order at the end.
export function byDateDesc(a: Dated, b: Dated): number {
  return entryDateValue(b.date) - entryDateValue(a.date);
}

// Featured entries first; everything after them stays in date order, so the
// pin is visible as a pin and the rest still reads as a record.
export function featuredThenDate(a: Dated, b: Dated): number {
  return (b.featured ? 1 : 0) - (a.featured ? 1 : 0) || byDateDesc(a, b);
}
